import { createAction, props } from '@ngrx/store';
import { MockEnclosureScenario } from 'app/core/testing/mock-enclosure/enums/mock-enclosure.enum';
import { EnclosureModel } from 'app/enums/enclosure-model.enum';
import { DebugTab } from 'app/modules/websocket-debug-panel/constants';
import { MockConfig } from 'app/modules/websocket-debug-panel/interfaces/mock-config.interface';
import { WebSocketDebugMessage } from 'app/modules/websocket-debug-panel/interfaces/websocket-debug.interface';

const actionPrefix = '[WebSocket Debug]';

export const messageReceived = createAction(
  `${actionPrefix} Message Received`,
  props<{ message: WebSocketDebugMessage }>(),
);

export const messageSent = createAction(
  `${actionPrefix} Message Sent`,
  props<{ message: WebSocketDebugMessage }>(),
);

export const clearMessages = createAction(
  `${actionPrefix} Clear Messages`,
);

export const togglePanel = createAction(
  `${actionPrefix} Toggle Panel`,
);

export const setPanelOpen = createAction(
  `${actionPrefix} Set Panel Open`,
  props<{ isOpen: boolean }>(),
);

export const setActiveTab = createAction(
  `${actionPrefix} Set Active Tab`,
  props<{ tab: DebugTab }>(),
);

export const addMockConfig = createAction(
  `${actionPrefix} Add Mock Config`,
  props<{ config: MockConfig }>(),
);

export const updateMockConfig = createAction(
  `${actionPrefix} Update Mock Config`,
  props<{ config: MockConfig }>(),
);

export const deleteMockConfig = createAction(
  `${actionPrefix} Delete Mock Config`,
  props<{ id: string }>(),
);

export const toggleMockConfig = createAction(
  `${actionPrefix} Toggle Mock Config`,
  props<{ id: string }>(),
);

export const loadMockConfigs = createAction(
  `${actionPrefix} Load Mock Configs`,
);

export const mockConfigsLoaded = createAction(
  `${actionPrefix} Mock Configs Loaded`,
  props<{ configs: MockConfig[] }>(),
);

export const saveMockConfigs = createAction(
  `${actionPrefix} Save Mock Configs`,
);

export const setMessageLimit = createAction(
  `${actionPrefix} Set Message Limit`,
  props<{ limit: number }>(),
);

export const exportMockConfigs = createAction(
  `${actionPrefix} Export Mock Configs`,
);

export const createMockFromResponse = createAction(
  `${actionPrefix} Create Mock From Response`,
  props<{ methodName: string; responseResult: unknown }>(),
);

export const clearPrefilledMockConfig = createAction(
  `${actionPrefix} Clear Prefilled Mock Config`,
);

export const toggleMessageExpansion = createAction(
  `${actionPrefix} Toggle Message Expansion`,
  props<{ messageId: string }>(),
);

// Enclosure Mock Actions
export const setEnclosureMockConfig = createAction(
  `${actionPrefix} Set Enclosure Mock Config`,
  props<{ config: {
    enabled: boolean;
    controllerModel: EnclosureModel | null;
    expansionModels: EnclosureModel[];
    scenario: MockEnclosureScenario;
  }; }>(),
);

export const toggleEnclosureMock = createAction(
  `${actionPrefix} Toggle Enclosure Mock`,
  props<{ enabled: boolean }>(),
);

export const updateEnclosureScenario = createAction(
  `${actionPrefix} Update Enclosure Scenario`,
  props<{ scenario: MockEnclosureScenario }>(),
);

export const loadEnclosureMockConfig = createAction(
  `${actionPrefix} Load Enclosure Mock Config`,
);

export const enclosureMockConfigLoaded = createAction(
  `${actionPrefix} Enclosure Mock Config Loaded`,
  props<{ config: {
    enabled: boolean;
    controllerModel: EnclosureModel | null;
    expansionModels: EnclosureModel[];
    scenario: MockEnclosureScenario;
  } | null; }>(),
);

// Duplicate Call Notification Actions
export const toggleDuplicateNotifications = createAction(
  `${actionPrefix} Toggle Duplicate Notifications`,
);

export const setDuplicateNotificationsEnabled = createAction(
  `${actionPrefix} Set Duplicate Notifications Enabled`,
  props<{ enabled: boolean }>(),
);
